module.exports = __webpack_public_path__ + "img/65.1.e2a7a9b2.jpg";